export const patrimony = {
  ref_patrimony: ' REF.PATRIMOINE ',
  adress_patrimony: ' ADRESSE ',
  manage_patrimony: ' Gérer les types de prestations',
};
